// composables/useDashboardNeu.js
function useDashboardNeu() {
  const { trace } = useTraceLog('composables->useDashboardNeu.js');
  const config = useRuntimeConfig();
  const dc_activar_dashboard = ref(config.public.activarDashboardNeumaticos || 'SI');

  const insertDashboardPersona = async (personaData) => {
    try {
      trace("dc_activar_dashboard.value: ", dc_activar_dashboard.value);
      if(dc_activar_dashboard.value === "NO"){ 
        trace("EL DASHBOARD NO ESTA ACTIVO");
        return "no activo";
      }

      const payload = {
        tipo: 'persona',
        personaData
      };

      const response = await $fetch('/api/neumaticos/dashboardneu', {
        method: 'POST',
        body: payload
      });

      trace("insertDashboardPersona() -> response: ", response);
      return response.data;
    } catch (error) {
      console.error('Error en insertDashboardPersona:', error);
      throw error;
    }
  };

  const insertDashboardData = async (dashboardData) => {
    try {
      trace("dc_activar_dashboard.value: ", dc_activar_dashboard.value);
      if(dc_activar_dashboard.value === "NO"){ 
        trace("EL DASHBOARD NO ESTA ACTIVO");
        return "no activo";
      }

      const payload = {
        tipo: 'dashboard',
        dashboardData
      };

      const response = await $fetch('/api/neumaticos/dashboardneu', {
        method: 'POST',
        body: payload
      });

      trace("insertDashboardData() -> response: ", response);
      return response.data;
    } catch (error) {
      console.error('Error en insertDashboardData:', error);
      throw error;
    }
  };

  const insertDashboardNeumaticos = async (neumaticosData) => {
    try {
      trace("dc_activar_dashboard.value: ", dc_activar_dashboard.value);
      if(dc_activar_dashboard.value === "NO"){ 
        trace("EL DASHBOARD NO ESTA ACTIVO");
        return "no activo";
      }

      const payload = {
        tipo: 'neumatico',
        neumaticosData
      };

      const response = await $fetch('/api/neumaticos/dashboardneu', {
        method: 'POST',
        body: payload
      });

      trace("insertDashboardNeumaticos() -> response: ", response);
      return response.data;
    } catch (error) {
      console.error('Error en insertDashboardNeumaticos:', error);
      throw error;
    }
  };

  const updateDashboardPersona = async (uuid, datos) => {
    trace("dc_activar_dashboard.value: ", dc_activar_dashboard.value);
    if(dc_activar_dashboard.value === "NO"){ 
      trace("EL DASHBOARD NO ESTA ACTIVO");
      return "no activo";
    }

    try {
      const payload = {
        tipo: 'persona',
        uuid,
        datos
      };

      const response = await $fetch('/api/neumaticos/dashboardneu', {
        method: 'PUT',
        body: payload
      });

      trace("updateDashboardPersona() -> response: ", response);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  const updateDashboardLocalCompra = async (uuid, localIdCompra) => {
    if(dc_activar_dashboard.value === "NO") return "no activo";

    const response = await $fetch('/api/neumaticos/dashboardneu', {
      method: 'PUT',
      body: {
        tipo: 'local_id_compra',
        uuid,
        datos: { local_id_compra: localIdCompra },
      },
    });

    return response.data;
  };

  return {
    insertDashboardPersona,
    insertDashboardData,
    insertDashboardNeumaticos,
    updateDashboardPersona,
    updateDashboardLocalCompra,
  }
}

export default useDashboardNeu